export const REQUESTS_LIST_COLUMNS_STRINGS = {
  requestType: 'Request Type',
  requestTypeFilterMenuAria: 'Filter requests by type',
  requestTypeFilterAll: 'All request types',
  status: 'Status',
  statusFilterMenuAria: 'Filter requests by status',
  statusFilterAll: 'All statuses',
  statusFilterApprovalSection: 'Approval requests',
  statusFilterCopyrightSection: 'Copyright requests',
  licensee: 'Licensee',
  publicationAuthorArrangerEditor: 'Arranger/Editor',
  publicationType: 'Publication Type',
  reviewType: 'Review Type',
  reviewTypeFilterMenuAria: 'Filter requests by review type',
  reviewTypeFilterAll: 'All review types',
  dateCreated: 'Date Created',
  actions: 'Actions',
  reviewRequest: 'Review request',
  copyright: 'Copyright',
  approval: 'Approval',
  unknown: 'Unknown',
} as const
